import { atom } from 'recoil';

export const newRegulatoryTrainingMatrixEditionsAtom = atom<
	Record<string, { id: number; checked: boolean; blockChecked: boolean }>
>({
	key: 'newRegulatoryTrainingMatrixEditions',
	default: {},
});
